import React from 'react'

const footer = () => {
  return (
    <div className="pt-5 mt-5 bg-green-dark">
      <div className="px-10 pt-5 bg-green-light">
        <span>Copyright © 2021, <strong>Okapi</strong> Oviedo - Asturias</span>
      </div>
    </div>
  )
}

export default footer
